module.exports = __webpack_public_path__ + "img/model_39_ug.1e4e2679.jpg";